import React from 'react';
import { connect, useSelector } from 'react-redux';

import { Loading, Notification } from '../../';

import authAction from '../../../redux/auth/actions';
import appActions from '../../../redux/app/actions';

const { logout } = authAction;
const { toggleAll } = appActions;

import { LayoutProps } from './index.d';
import { theme, ThemeProvider } from '@l_ine/core';
import { themeConfig } from '../../../config';

const Layout: React.FC<LayoutProps> = props => {
  const { cor_principal } = useSelector((State: any) => {
    return {
      nome: State.Company.companyInfo?.nome || '',
      cor_principal: State.Company.companyInfo?.cor_principal || '',
    };
  });

  const themeUser = theme.createTheme({
    palette: {
      primary: {
        color: cor_principal,
        contrast: '#FFFFFF',
      },
      neutral: {
        color: '#ECECEC',
        contrast: '#000',
      },
    },
  });
  return (
    <ThemeProvider theme={cor_principal ? themeUser : themeConfig.current}>
      <div>
        <header>
          <>
            <Notification />
            {props.App.loading && <Loading />}
            {props.children}
          </>
        </header>
      </div>
    </ThemeProvider>
  );
};

export default connect(
  (state: any) => ({
    auth: state.Auth,
    App: state.App,
    Company: state.Company,
  }),
  { logout, toggleAll }
)(Layout);
